<template>
  <div class="block-bilde">
    <img
      v-if="value.BildeMobil"
      :src="getUrl(mobile)"
      class="padding block-bilde__mobile"
    />
    <img :src="getUrl(desktop)" class="padding block-bilde__default" />
    <p class="uk-text-meta">{{ caption }}</p>
  </div>
</template>

<script>
import Renderer from "./mixin";
export default {
  props: {
    value: Object,
  },
  computed: {
    mobile() {
      return this.value.BildeMobil.url;
    },
    desktop() {
      return this.value.Bilde.url;
    },
    caption() {
      if (this.$i18n.locale == "no") {
        return this.Caption;
      } else {
        return this.Caption_eng;
      }
    },
  },
  methods: {
    getUrl(value) {
      if (!value || value.startsWith("http")) return value;

      return this.$api_url + value;
    },
  },
  mixins: [Renderer(["Caption", "Caption_eng"])],
};
</script>

<style lang="scss">
.block-bilde {
  padding-bottom: 0rem;

  &__mobile {
    display: none;

    @media (max-width: $mobile) {
      display: block;

      & + img {
        display: none;
      }
    }
  }
}
</style>
